// extracted by mini-css-extract-plugin
export default {"pageWrap":"Pa-z","fullWidth":"Qa-z","heading":"Ra-z","fullBleed":"Sa-z","hidden":"Ta-z"};